import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { Subject, takeUntil } from 'rxjs';
import { AppUtilityService } from 'src/app/app-utility.service';
import { FinbondFileModel } from 'src/app/core/models/finbondFile.model';
import { LoanDocModel } from 'src/app/core/models/loanDoc.model';
import { ErrorhanderService } from 'src/app/core/services/error-handler.service';
import { UserService } from 'src/app/core/services/lmsuser.service';
import { LMSDialogHandlerService } from 'src/app/shared/lmsdialog-handler.service';
import {
  MdbButtonModule, MdbFormsModule, MdbModalRef, MdbOptionModule, MdbRippleModule, MdbSelectModule,
} from 'src/lib/mdb5-adapted/public-api';

import { ClientDetailsService } from '@lmsrestServices';
import { LmsTableWrapperComponent } from '@lmsShared';
import { LmsModalFrameComponent } from '@lmsSharedUI';

//
//  NOTE TO ALL DEVELOPERS!!! DO NOT CHANGE ANYTHING ON THIS COMPONENT!!!
//

@Component({
  selector: 'app-document-scanning',
  templateUrl: './document-scanning.component.html',
  styleUrls: ['./document-scanning.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LmsModalFrameComponent,
    MdbButtonModule,
    MdbRippleModule,
    ReactiveFormsModule,
    MdbFormsModule,
    MdbOptionModule,
    MdbSelectModule,
    NgxPaginationModule,
    LmsTableWrapperComponent,
  ],
})
export class DocumentScanningComponent implements OnInit, OnDestroy {
  private lmsDialogHandler = inject(LMSDialogHandlerService);
  private readonly destroy$ = new Subject<void>();

  loanDoc: LoanDocModel = new LoanDocModel();
  curr: any;
  downloadObject: any = {};
  finalFileName: any;
  downloadResults: any = {};
  clientDetails: any;
  quoteId: any;
  requiredDocs: any[] = [];
  lstDocuments: any[] = [];
  selectedDocType: any;
  selectedDocTypeControl = new FormControl<any | null>(null);

  //PAGINATOR CODE
  config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 5,
    currentPage: 1,
  };

  @Input() items: any[];
  @Output() changePage = new EventEmitter<any>(true);
  @Input() initialPage = 1;
  @Input() pageSize = 5;
  @Input() maxPages = 1;

  fromLoanDetails = false;
  uploadedFromLoanDetails = false;

  docCount = 1;

  isReadOnly: boolean;
  clientStatus: string;
  constructor(
    private clientDetailsService: ClientDetailsService,
    private userService: UserService,
    private errorHandler: ErrorhanderService,
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<DocumentScanningComponent>
  ) {}

 ngOnInit(): void {
  this.loanDoc = new LoanDocModel();
  this.clientStatus = this.clientDetails.clientStatus;

  this.selectedDocTypeControl.valueChanges
    .pipe(takeUntil(this.destroy$))
    .subscribe((selectedDocType) => {
      this.onReqDocSelect(selectedDocType);
    });

  this.listClientDocs();
}

  // ngOnChanges(changes: SimpleChanges) {
  //   // reset page if items array has changed
  //   if (changes.currentValue !== changes.previousValue) {
  //     this.setPage(this.initialPage);
  //   }
  // }

  onReqDocSelect(selectedDocType: any) {
    this.selectedDocType = selectedDocType;

    if (!this.selectedDocType) {
      this.loanDoc.documentName = '';
      this.loanDoc.docId = '';
      this.loanDoc.documentType = '';
      this.loanDoc.checkListId = 0;
      return;
    }

    this.loanDoc.documentName = this.selectedDocType.documentName;
    this.loanDoc.docId = this.selectedDocType.id;
    this.loanDoc.documentType = this.selectedDocType.documentType;
    this.loanDoc.checkListId = this.selectedDocType.id ?? 0;
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    // this.fileName = file.name;
    const finbondFile = new FinbondFileModel();
    finbondFile.fileName = file.name;
    finbondFile.contentType = file.type;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        finbondFile.fileContents = (reader.result as string).split(',')[1];
        // this.loanDoc.file = finbondFile;
        this.loanDoc.contentType = finbondFile.contentType;
        this.loanDoc.originalFileName = finbondFile.fileName;
        this.loanDoc.documentContents = finbondFile.fileContents;
      }
    };
  }

  onDocumentSubmit() {
    if (!this.loanDoc.documentType) {
      // alert('Please select a document from the list');
      this.global_utility.info(`Please select *loanDoc.documentType* a document from the list`, 'Document list');
      return;
    }

    if (!this.loanDoc.originalFileName) {
      //alert('Please choose a file to be submitted');
      this.global_utility.info(`Please select a file from the list`, 'Document list');
      return;
    }

    this.global_utility.startLoading('Submitting document.');
    // this.isLoading = true;

    // Add flag to filename if uploaded from loan-details
    if (this.fromLoanDetails) {
      const timestamp = new Date().getTime();
      this.loanDoc.originalFileName = `[LD-MANUAL]_${this.loanDoc.originalFileName}`;
      this.uploadedFromLoanDetails = true;
    }

    this.loanDoc.idNumber = this.clientDetails.idNumber;
    this.loanDoc.customerId = this.clientDetails.clientNumber;
    this.loanDoc.loanId = 'Q' + this.quoteId;
    this.loanDoc.userName = this.userService.userLoginName;
    this.loanDoc.applicationId = this.quoteId;
    //this.loanDoc.checkListId = this.fromLoanDetails ? '0' : (this.loanDoc.docId?.toString() ?? '0');

    if (this.fromLoanDetails) {
    this.loanDoc.docId = "0";
    this.loanDoc.checkListId = 0;
    } else {
    this.loanDoc.checkListId = this.loanDoc.docId ? Number(this.loanDoc.docId) : 0;
    }

    this.clientDetailsService.uploadDocument(this.loanDoc).subscribe({
      next:(res) => {
        if (!res) {
          this.global_utility.error(
            `An upload error has occured. Please check that the document is valid and try again`,
            'Document list'
          );
          return;
        }

        res.isNewUpload = true;
        this.lstDocuments.unshift(res);
        this.global_utility.stopLoading();
        this.listClientDocs();
        this.loanDoc = new LoanDocModel();
      },
      error:(err) => {
        console.error('Document Upload failed', err.message || err);
        this.global_utility.stopLoading();
        this.global_utility.error(err, 'Document Upload failed');
      },
    });
  }

  onDownloadPdf(data: any) {
    this.curr = JSON.stringify(data);
    this.finalFileName = this.curr.split('"').join('');
    console.log('Curr ' + this.finalFileName);

    this.downloadObject.fileName = this.finalFileName;
    this.downloadObject.bucketName = '';
    this.downloadObject.userName = '';
    this.downloadObject.originalFileName = '';

    this.clientDetailsService.downloadRaw(this.downloadObject).subscribe((res: any) => {
      this.downloadResults = res;
      const base64String = this.downloadResults.documentContent;

      this.openPdfViewer(base64String, this.downloadResults.originalFilename, this.downloadResults.contentType);
    });
  }

  openPdfViewer(base64String: any, fileName: string, contentType: string) {
    const source = `data:` + contentType + `;base64,` + `${base64String}`;
    this.lmsDialogHandler.openDocumentViewer(source, fileName);
  }

  close() {
    this.dialogRef.close('Closed');
  }

  listClientDocs() {
    this.loanDoc.quoteId = 'Q' + this.quoteId;
    this.clientDetailsService.listClientDocs(this.loanDoc).subscribe((res) => {
      if (res) {
        this.lstDocuments = res;

        for (const doc of this.lstDocuments) {
          doc.documentType = doc.documentType.replaceAll('_', ' ');

          if (doc.checklistId?.includes('_')) {
            let counter = doc.checklistId.substring(doc.checklistId.indexOf('_') + 1);
            counter = +counter + 1;
            this.docCount = counter > this.docCount ? counter : +this.docCount;
          }
        }

        this.getDocChecklist().then((dropList) => {
          if (dropList) {
            this.requiredDocs.push({
              id: `${this.quoteId}_${this.docCount}`,
              documentName: 'Proof of Residence',
              documentType: 'PROOF_OF_RESIDENCE',
            });
            this.requiredDocs.push({
              id: `${this.quoteId}_${this.docCount}`,
              documentName: 'Other',
              documentType: 'OTHER',
            });
          }
        })
        .catch((err) => {
          this.errorHandler.handle(err);
        });
      }
    });
  }

  private loanDetailsRequiredDocs = [
  { id: '', documentName: 'ID Document', documentType: 'ID_DOCUMENT' },
  //{ id: '', documentName: 'Proof of address', documentType: 'PROOF_OF_ADDRESS' },
  { id: '', documentName: 'Proof of Income', documentType: 'PROOF_OF_INCOME' },
  { id: '', documentName: 'Bank Statement', documentType: 'BANK_STATEMENTS' },
  { id: '', documentName: 'Risk Matrix tool', documentType: 'RISK_MATRIX' },
  { id: '', documentName: 'Paid up letter', documentType: 'PAID_UP_LETTER' },
  { id: '', documentName: 'MyBenefits', documentType: 'MY_BENEFITS' },
  { id: '', documentName: 'Existing Debt obligation', documentType: 'EXISTING_DEBT_OBLIGATIONS' },
  { id: '', documentName: 'Pre agreement', documentType: 'PRE_AGREEMENT' },
  { id: '', documentName: 'AUL agreement', documentType: 'AUL_AGREEMENT' },
  { id: '', documentName: 'Section 93 Acknowledgement', documentType: 'SECTION_93' },
  { id: '', documentName: 'Loan Summary', documentType: 'LOAN_SUMMARY' }
];

  getDocChecklist() {
    return new Promise((resolve, reject) => {
      const qid: number = this.quoteId;

      if (this.fromLoanDetails) {
          this.requiredDocs = this.loanDetailsRequiredDocs.map(doc => ({
            ...doc,
            id: `${this.quoteId}`,
            frontendId: `${this.quoteId}_${this.docCount}`
          }));
        resolve(this.requiredDocs);
      } else {
        this.clientDetailsService.getDocChecklist(qid).subscribe({
          next: (dbChecklist) => {
            if (dbChecklist) {
              this.requiredDocs = dbChecklist;
            }
            resolve(this.requiredDocs);
          },
          error: (err) => {
            this.errorHandler.handle(err);
            reject(new Error(err));
          },
        });
      }
    });
  }

  canDeleteDocument(doc: any): boolean {
    if (this.isReadOnly || doc.documentType === 'CODIX REPORT') {
      return false;
    }

    const hasLoanDetailsFlag = doc.originalFileName?.includes('[LD-') || doc.uploadedFromLoanDetails;

    return this.fromLoanDetails ? hasLoanDetailsFlag : true;
  }

  deleteDocument(doc: any) {
    this.global_utility.startLoading('Submitting document..');
    doc.quoteId = this.quoteId;
    doc.idNumber = this.clientDetails.idNumber;
    doc.userName = this.userService.userLoginName;

    if (doc.documentType == 'RISK ANALYSIS' || doc.documentType == 'COMPUSCAN OFFER') {
      this.global_utility.error(`Document ${doc.documentType} cannot be deleted`, 'Document list');
    } else {
      this.clientDetailsService.deleteDocument(doc).subscribe((res) => {
        if (res) {
          this.requiredDocs = res;
          this.listClientDocs();
        }
        this.global_utility.stopLoading();
      });
    }
  }

  confirmDocumentScanningDetails() {
    this.loanDoc.isConfirmedDocScanningDetails = true;

    this.dialogRef.close('Confirmed');
  }

  covertDate(date: any) {
    if (date != null) {
      let str = date;
      str = str.substring(0, 10);
      date = str;
      return date;
    } else {
      return date;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
